function paginateGames(games, page, gamesPerPage) {
  if (!Array.isArray(games)) {
    return games;
  }

  return games.slice(0, page * gamesPerPage);
}

exports.paginateGames = paginateGames;